import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { PatientsData } from '../../models/commonmodel';
import { CommonModule } from '@angular/common';
import { AgePipe } from '../shared/pipes/age.pipe';
import { StatusLablesComponent } from '../shared/components/status-lables/status-lables.component';
import { NoDataFoundComponent } from '../shared/no-data-found/no-data-found.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { AddApplicantComponent } from '../distributor/add-applicant/add-applicant.component';
import { DialogRef } from '@angular/cdk/dialog';
import { PatientProfileComponent } from '../patient-profile/patient-profile.component';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
@Component({
  selector: 'app-table-list-view',
  standalone: true,
  imports: [
    CommonModule,
    AgePipe,
    StatusLablesComponent,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    FormsModule
  ],
  templateUrl: './table-list-view.component.html',
  styleUrl: './table-list-view.component.scss'
})
export class TableListViewComponent implements AfterViewInit, OnChanges {

  @Input() data: any[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() columnDisplayNames: string[] = []; // 👈 Add this
  @Input() enumRole: any;
  @Input() enumEntityType: any;
  items: any;
  @Input() tableFrom: string = ''; // Source identifier for the table
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource = new MatTableDataSource<PatientsData>();

  // Outputs
  @Output() openPatientProfile = new EventEmitter<any>();
  @Output() openMedicalEvidence = new EventEmitter<any>();
  @Output() openRequestMoreDetails = new EventEmitter<any>();
  @Output() openAddPatientModal = new EventEmitter<any>();
  @Output() openRequestME = new EventEmitter<any>();
  @Output() onFillMoreInfo = new EventEmitter<any>();
  @Output() onViewDocuments = new EventEmitter<any>();
  @Output() updateStatus = new EventEmitter<{ item: any, isActive: boolean }>();
  @Input() getTurnAroundTime: (row: any) => string = () => '';
  paginatedData: any[] = [];
  constructor(private matdialog: MatDialog) { }

  // pageSize:number=5;
  // curentPage:number=1;
  // totalPages=0;
  pageSize = 6; // Default page size
  currentPage = 1;
  totalPages = 0;
  itemsPerPage = 6;
  pageSizeOptions: number[] = [8, 10, 20, 50];

  ngAfterviewInit() {
    this.pagination()
  }


  ngOnInit() {
    this.paginatedData = this.data;
    this.items = this.data;
    this.pagination()
    this.calculateTotalPages();
    this.updatePaginatedData();
    this.dataSource.paginator = this.paginator;
    // this.items = this.dataSource.data;
    this.items = this.data;
    console.log("initi", this.items)

    this.paginatedData = this.items.slice(0, this.pageSize);

  }




  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.items = this.dataSource.data;
    this.items.paginator = this.paginator;

  }


  ngOnChanges() {
   this.paginatedData = this.data;
    this.items = this.data;
    this.pagination()
    this.calculateTotalPages();
    this.updatePaginatedData();
    this.dataSource.paginator = this.paginator;
    // this.items = this.dataSource.data;
    this.items = this.data;
    console.log("initi", this.items)

    this.paginatedData = this.items.slice(0, this.pageSize);
  }

  calculateTotalPages() {
    this.totalPages = Math.ceil(this.items.length / this.pageSize);
    console.log(this.totalPages)
  }
  onPreviousPage() {

    if (this.pageSize > 0) {

      const startIndex = this.pageSize;
      const endIndex = this.pageSize - this.pageSize;
      this.paginatedData = this.data.slice(startIndex, endIndex);


    }
  }


  // totalPages=0;
  openPatientProfileDistributor // totalPages=0;
    (data: any) {
    const openPatientconfig = new MatDialogConfig();
    openPatientconfig.data = data;

    const opepatientProfileRef = this.matdialog.open(PatientProfileComponent, openPatientconfig)
    console.log(opepatientProfileRef)
  }
  openPatientForm(patientdata: any) {
    console.log(patientdata);
    const openPatientconfig = new MatDialogConfig();
    openPatientconfig.width = '950px';
    openPatientconfig.height = '700px';
    openPatientconfig.data = patientdata;
    const openPatientRef = this.matdialog.open(AddApplicantComponent, openPatientconfig)
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateVisibleItems();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateVisibleItems();
    }
  }

  getBorderClass(item: any): string {
    if (item.serviceRequest?.status === 'RECEIVED') return 'border-left-received';
    if (item.serviceRequest?.status === 'INPROGRESS') return 'border-left-inprogress';
    if (item.serviceRequest?.status === 'REQUESTED') return 'border-left-requested';
    if (item.status === 'OPEN') return 'border-left-open';
    if (item.serviceRequest?.status === 'MORE_INFO_REQUESTED') return 'border-left-more';
    return '';
  }


  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateVisibleItems();
    }
  }

  updateVisibleItems(): void {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    this.paginatedData = this.items.slice(start, end);


  }
  pagination() {

    this.paginatedData = this.items.slice(0, this.pageSize);
    console.log(this.paginatedData)
  }


  updatePaginatedData() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.data.slice(startIndex, endIndex);
  }
  onNextpage() {
    console.log(this.pageSize);
    if (this.pageSize > 0) {

      const startIndex = this.pageSize;
      const endIndex = this.pageSize + this.pageSize;
      this.paginatedData = this.data.slice(startIndex, endIndex);


    }


  }
  onPageSizeChange(event: Event) {
    const newSize = +(event.target as HTMLSelectElement).value;
    if (newSize > 0) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.calculateTotalPages();
      this.updatePaginatedData();
    }
  }


  onPagesize(size: string) {
    this.pageSize = Number(size);


  }
  sortData() {
    // console.log(sortvalue);
    this.data.sort((a, b) => {
      const Avalue = a.serviceRequest.status;
      const Bvalue = b.serviceRequest.status;
      console.log(Avalue.localCompare(Bvalue))

      return Avalue.localCompare(Bvalue);


    });

    console.log(this.data)
    this.data = [...this.data]
  }

  confirmStatusUpdate(item: any, isActive: boolean, event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    const dialogRef = this.matdialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'Add';
    dialogRef.componentInstance.message = 'Are you sure you want to update the status?';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.updateStatus.emit({ item, isActive });
      }
    });
  }
}
